module.exports = __webpack_public_path__ + "static/media/standard_size.dba634a3.png";